/* Selection model only. This file never creates or changes a Shopify cart. */
(function (scope) {
 'use strict';
 const fresh = () => ({pack:4,picks:[],mode:'custom',bundles:[]});
 function restore(value, catalog) {
  const result=fresh(), ids=new Set(catalog.map(p=>String(p.id)));
  if (!value || typeof value!=='object') return result;
  result.pack=value.pack===7?7:4;
  result.picks=Array.isArray(value.picks)?value.picks.filter(id=>typeof id==='string'&&ids.has(id)).slice(0,7):[];
  result.mode=value.mode==='curated'?'curated':'custom';
  result.bundles=Array.isArray(value.bundles)?value.bundles.filter(b=>b&&[4,7].includes(b.pack)&&Array.isArray(b.picks)&&b.picks.length===b.pack&&b.picks.every(id=>typeof id==='string'&&ids.has(id))).slice(0,10).map(b=>({pack:b.pack,picks:[...b.picks]})):[];
  return result;
 }
 function complete(state,catalog) {return state.picks.length===state.pack&&state.picks.every(id=>catalog.some(p=>String(p.id)===id&&p.available));}
 function add(state,id,catalog,swap=null) {
  const p=catalog.find(p=>String(p.id)===id);if(!p?.available)return false;
  if(swap!==null){if(!Number.isInteger(swap)||swap<0||swap>=state.picks.length)return false;state.picks[swap]=id;return true;}
  if(state.picks.length>=state.pack)return false;state.picks.push(id);return true;
 }
 function remove(state,index) {if(!Number.isInteger(index)||index<0||index>=state.picks.length)return false;state.picks.splice(index,1);return true;}
 function setPack(state,size){if(![4,7].includes(size))return false;state.pack=size;return true;}
 function priceSafety(state,catalog,currency='USD') {
  const bundleMinor=state.pack===4?6900:state.pack===7?11900:null;
  const fail=status=>({status,eligible:false,currency,bundleMinor,individualMinor:null,differenceMinor:null});
  if(!bundleMinor)return fail('pack');
  if(currency!=='USD')return fail('currency');
  const status=complete(state,catalog)?'fixed':'incomplete';
  return {status,eligible:status==='fixed',currency,bundleMinor,individualMinor:null,differenceMinor:null};
 }
 function saveBundle(state,catalog,currency='USD'){if(!priceSafety(state,catalog,currency).eligible||state.bundles.length>=10)return false;state.bundles.push({pack:state.pack,picks:[...state.picks]});state.picks=[];state.mode='custom';return true;}
 function removeBundle(state,index){if(!Number.isInteger(index)||index<0||index>=state.bundles.length)return false;state.bundles.splice(index,1);return true;}
 const boxes=state=>state.bundles.filter(b=>b.pack===7).length;
 function selection(state,catalog,currency='USD') {
  const priceCheck=priceSafety(state,catalog,currency);if(!priceCheck.eligible)return null;
  const quantities=new Map();for(const variantId of state.picks)quantities.set(variantId,(quantities.get(variantId)||0)+1);
  return {schemaVersion:2,priceCheck,sockCount:state.pack,items:[...quantities].map(([variantId,quantity])=>({variantId,quantity})),packaging:state.pack===7?{mode:'included-outer-box',boxQuantity:1,consumesSockSlot:false,orderMappingVerified:false}:null,checkoutEnabled:false};
 }
 // Theme-owned read-only contract. Vendor adapter/SDK must validate every item,
 // price, eligibility, box rule and cart grouping before any commerce handoff.
 const api={fresh,restore,complete,add,remove,setPack,saveBundle,removeBundle,boxes,selection,priceSafety};
 if(typeof module!=='undefined'&&module.exports)module.exports=api;else scope.DeadSoxyBundleStageModel=api;
})(typeof window==='undefined'?globalThis:window);
